import { isAdminRole } from "../shared/utils";

export default function PrivatePage({ children, roles = [] }) {
  if (roles.includes("admin") && isAdminRole()) {
    return children;
  }

  window.location.href = "/home";
  return <></>;
}
